import * as React from 'react';
const { forwardRef, useState } = React;
import InputAdornment from '@material-ui/core/InputAdornment';
import { makeStyles } from '@material-ui/core/styles';

import TextField, { TextFieldProps } from '../text-field';
import IconButton from '../icon-button';
import Icon from '../icon';


const useIconButtonStyles = makeStyles((theme) => ({
	iconButton: {
		padding: '6px',
		'&.MuiIconButton-edgeEnd': {
			marginRight: 0
		}
	}
}));

type PasswordTextFieldProps = {} & TextFieldProps;

const PasswordTextField = forwardRef<any, PasswordTextFieldProps>((props, ref) => {
	const [showPassword, setShowPassword] = useState(false);
	const handleClickShowPassword = () => setShowPassword(!showPassword);
	const classes = useIconButtonStyles({});

	return (
		<TextField
			ref={ref}
			{...props}
			type={showPassword ? 'text' : 'password'}
			InputProps={{
				endAdornment: (
					<InputAdornment position='end'>
						<IconButton
							edge='end'
							aria-label='Изменить видимость пароля'
							title='Изменить видимость пароля'
							className={classes.iconButton}
							onClick={handleClickShowPassword}>
							<Icon
								type={showPassword ? 'visibility-off' : 'visibility'}
								color='primary'
								width={20}
								height={20}
							/>
						</IconButton>
					</InputAdornment>
				),
			}}
		/>
	);
});

export default PasswordTextField;
